import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { EnterpriseRoutingComponent } from './components/enterprise-routing/enterprise-routing.component';
import { EnterpriseSettingsComponent } from './components/enterprise-settings/enterprise-settings.component';
import { EnterprisesPageComponent } from './components/enterprises-page/enterprises-page.component';
import { UpdateEnterpriseSBCComponent } from './components/update-enterprise-sbc/update-enterprise-sbc.component';

@NgModule({
  imports: [SharedModule, ReactiveFormsModule],
  declarations: [
    EnterprisesPageComponent,
    EnterpriseRoutingComponent,
    EnterpriseSettingsComponent,
    UpdateEnterpriseSBCComponent,
  ],
})
export class EnterprisesModule {}
